var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "report_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-icons-/-rapports-(green)",
    transform: "translate(-1.000000, -1.000000)",
    fill: "#37DC58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0000234,14.242962 L19.0000234,20.007962 C18.9998231,20.271162 18.8950231,20.523462 18.7088231,20.709462 C18.5226231,20.895562 18.2702231,20.999962 18.0070231,20.999962 L1.99304312,20.999962 C1.86172312,20.999062 1.73187312,20.972262 1.61089312,20.921162 C1.48991812,20.870062 1.38019312,20.795662 1.28798412,20.702162 C1.19577512,20.608662 1.12288712,20.497862 1.07348312,20.376262 C1.02407812,20.254562 0.999125119,20.124362 1.00002342,19.992962 L1.00002342,8 L7.00004312,8 C7.26526312,8 7.51962312,7.894642 7.70715312,7.707102 C7.89469312,7.519572 8.00004312,7.265212 8.00004312,7 L8.00004312,1 L18.0020231,1 C18.5530231,1 19.0000234,1.455002 19.0000234,1.992002 L19.0000234,5.757002 L10.0010531,14.756962 L9.99504312,18.994962 L14.2410231,19.000962 L19.0000234,14.242962 Z M19.7780231,7.808002 L21.1920231,9.222002 L13.4140231,16.999962 L11.9980231,16.997962 L12.0000231,15.585962 L19.7780231,7.808002 Z M1.00004812,6.000002 L6.00004812,1.003 L6.00004812,6.000002 L1.00004812,6.000002 Z",
    id: "report_selected"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportSelected);
export default __webpack_public_path__ + "static/media/report_selected.7eff3a10e8694c8aae32542ea119333d.svg";
export { ForwardRef as ReactComponent };